import { Box } from "@mui/material";
import { forwardRef } from "react";

const CropperContainer = forwardRef(({children}, ref) => {
  return (
    <Box 
      id="cp-view-main" 
      ref={ref} 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        height: '100%',
        position: 'relative',
    }}>
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
      }}>
        {children}
      </Box>
    </Box>
  );
});

export default CropperContainer;